module.exports = __webpack_public_path__ + "static/media/bg-celebrate-our-love-mobile.6ead2a75.png";